import { Text, View, Image } from 'components';
import BuyTopModal from '../../components/buyTopModal';
import WorkItem from '../../components/workItem';
// import Modal from 'react-modal';
import Base, { Config } from 'components/megatron/Base';
import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


interface State {
  data: any[]
  selected?: number
  visible: boolean
}

export default class SelectEmploy extends Base {
  public config: Config = {
    navigationBarTitleText: '选择招聘'
  };

  public state: State = {
    data: [],
    visible: false
  }

  public didMount(){
    this.getList()
  }

  public render() {
    const { data, selected, visible } = this.state;
    return (
      <View className={styles.container}>
        <ToastContainer className={styles.ToastContainer}/>
        <View className={styles.lists}>
          {data.map(job => (
            <View className={this.cx(styles.sec, {
              [styles.active]: job.id == selected
            })}
              onClick={this.handleSelect.bind(null, job)}
            >
              <WorkItem cssClass={styles.item} key={job.id} data={job}/>
              <View className={styles.mask}>
                <Image className={styles.ico} src={this.assets.megatron.selected1}/>
              </View>
            </View>
          ))}
        </View>
        <View className={this.cx(styles.btn, {
          [styles.active]: !!selected
        })} onClick={this.handleRoute}>
          {this.btnText}
        </View>

        <BuyTopModal visible={visible} jid={selected} onClose={this.toggleVisible.bind(null,false)} />

      </View>
    );
  }

  private toggleVisible = (bol:boolean = true) => {
    this.setState({
      visible: bol
    })
  }

  private get btnText(){
    const { selected } = this.state
    return !!selected? '确认选择，为选中招聘置顶': '请选择要置顶的招聘'
  }

  private getList = async() => {
    const {status, body, msg} = await this.apiClient.base.manage()
    if(status != 10000){
      toast.error(msg, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      return;
    }

    this.setState({
      data: body
    })

  }

  private handleSelect = job => {
    if(job.state != 1){
      let msg = '请选择有效招聘进行置顶'
      toast.error(msg, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      return;
    }
    this.setState({
      selected: job.id
    })
  }

  private handleRoute = () => {
    const { selected } = this.state
    if(!selected){
      return;
    }

    this.toggleVisible()
    
  }

  


}
